import DamageStatusHelper from "./damage-status-helper";
import {
    damageFilterFieldsConfig,
    getDamageFilterInitialValues,
    getDamageActiveFiltersCount,
    buildDamageFilterState
} from "./damage-filter-config";


const DamageHelpers = {
    Status: DamageStatusHelper,
    Filter: {
        fieldsConfig: damageFilterFieldsConfig,
        getInitialValues: getDamageFilterInitialValues,
        getActiveFiltersCount: getDamageActiveFiltersCount,
        buildFilterState: buildDamageFilterState
    }
};

export default DamageHelpers;